import React, { useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { useEventListener } from "../../../../../../helpers/useEventListener";
import SelectedIcon from "../../../../../../assets/images/SelectedIcon.svg";
import { idNamingConversion } from "../../../../../../helpers/utilities";
import { BarCodeComponent } from './BarCodeComponent';


export const LineRow = React.forwardRef((props, ref) => {
    const { classes, clsx, myProductdetails, productApi,
        viewType, activeInputs, showNameDesc,
        roleManagement, checkComponentPermission, visible, handleGridClick, selected } = props;
    let autoCompleteRef = '';
    const barcodeRef = useRef('');

    const handleKeyDown = (e) => {
        if (!visible) {
            if ((viewType === 'tile' && e.keyCode === 13) || (activeInputs && viewType === 'keyboard' && e.keyCode === 40)) {
                e.preventDefault();
                if (myProductdetails?.length < 50) {
                    productApi();
                }
                autoCompleteRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(() => {
                    autoCompleteRef.current.focus();
                    autoCompleteRef.current.select();
                }, 500)
            } else if (viewType === 'barcode' && e.keyCode === 13) {
                barcodeRef.current.onFocus()
            }
        }
    };

    useEventListener("keydown", handleKeyDown);

    return (
        <>
            {
                roleManagement !== '' && checkComponentPermission('Store Sales', 'Page', 'Product Dropdown') &&
                <TableContainer className={clsx(classes.tablecontain)} style={{ borderTop: "1px solid rgba(224, 224, 224, 1)", overflow: "hidden", height: "auto" }}>
                    <Table stickyHeader>
                        <TableBody>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                <TableCell style={{ width: 55 }}>
                                    <span style={{ display: "inline-block", verticalAlign: "middle", opacity: 0 }} className={classes.selectedIconView}><img src={SelectedIcon} alt={"empty product"} /></span>
                                    <span style={{ display: "inline-block", verticalAlign: "middle" }}>{selected?.length + 1}</span>

                                </TableCell>
                                <TableCell className={clsx(classes.customerLabelNone)} style={{ width: 250 }}>
                                    {
                                        viewType === 'barcode' ? <BarCodeComponent
                                            {...props}
                                            ref={barcodeRef}
                                        /> : <AutoCompleteComponent
                                            setRef={(ref) => { autoCompleteRef = ref }}
                                            customLabel={"Product"}
                                            heads={[{ 'key': showNameDesc === 'name' ? 'productName' : 'description', 'name': 'Product Name' },
                                            { 'key': 'code', 'name': 'Product Code' },
                                            { 'key': 'productId', 'name': 'Product ID' }]}
                                            details={myProductdetails?.filter(f => selected?.every(item => item.productId !== f.id))}
                                            parentValue={[]}
                                            position={"top"}
                                            variant={'outlined'}
                                            orginPosVet={1}
                                            id={idNamingConversion('Product', 'storeSalesLine', 'DropDown')}
                                            searchLength={0}
                                            searchType={(s) => productApi(s)}
                                            orginPosHor={-180}
                                            onChange={(d) => { if (d?.id) { handleGridClick(d) } }}
                                        />
                                    }
                                </TableCell>
                                <TableCell colSpan={5}></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </>
    )
})